import { Component, OnDestroy, Renderer2, Input } from '@angular/core';

@Component({
  standalone: false,
    selector: 'app-modal-popup',
    templateUrl: './popup-modal.component.html',
    styleUrls: ['./popup-modal.component.scss']
})
export class ModalPopupComponent implements OnDestroy {
    @Input() custom: boolean;
    constructor(private _renderer: Renderer2) {
        const overlays = document.querySelectorAll('.modal-popup-overlay');
        for (const overlay of Array.from(overlays)) {
            overlay.setAttribute('style', 'background: transparent');
        }
    }

    ngOnDestroy() {
        const overlays = document.querySelectorAll('.modal-popup-overlay');
        for (const overlay of Array.from(overlays)) {
            overlay.removeAttribute('style');
        }
    }
}
